export default __webpack_public_path__ + "static/media/799.41ab8963.png";